module.exports = __webpack_public_path__ + "images/bg-gradient-3-rotated-2.png";